module.exports = __webpack_public_path__ + "img/goods_03.de1c619e.jpg";